// eslint-disable
import PARSE from "html-react-parser";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Api from "./Api";
import { Helmet } from "react-helmet";

const api = new Api();

export default function SSoftNew_Hero_About() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);

  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [boxContent, setBoxContent] = useState(null); // Text content
  const [listButton, setListButton] = useState(null); // Buttons

  // Fetch section data based on active language
  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  // Process widgets once sections are loaded
  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              // Overflowing image (the person on screen/tablet)
              setBoxContent(section?.widget_contents[0]);
              break;
            }

            case 1: {
              // Buttons
              setListButton(section?.widget_contents[0]);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted >= 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  // Render skeleton while loading
  if (!loaded) {
    return (
      <Skeleton
        width="100%"
        className="!z-[100] qhd:!h-[calc(60vh+78px)] md:!h-[calc(585px+78px)] h-[calc(60vh+78px)]"
      />
    );
  }

  return (
    <>
      <Helmet>
        {/* ==== BASIC SEO ==== */}
        <title>
          About PT Supersoft Sistemindo | Infor & Octave Attune (Hexagon)
          Partner Indonesia Since 1991
        </title>
        <meta
          name="description"
          content="PT Supersoft Sistemindo adalah partner resmi Infor & Octave Attune (Hexagon) di Indonesia sejak 1991. Kami memberdayakan organisasi lintas industri melalui solusi digital enterprise untuk manajemen keuangan, aset, dan performa yang lebih cerdas."
        />
        <meta
          name="keywords"
          content="PT Supersoft Sistemindo, Infor Partner Indonesia, Octave Attune EAM (Hexagon) Indonesia, digital enterprise solutions, Infor SunSystems, Infor EPM, Octave Attune EAM, implementasi Infor Indonesia"
        />
        <link rel="canonical" href="https://ptsupersoft.com/about" />

        {/* ==== OPEN GRAPH ==== */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ptsupersoft.com/about" />
        <meta
          property="og:title"
          content="About PT Supersoft Sistemindo | Infor & Octave Attune (Hexagon) Partner Indonesia Since 1991"
        />
        <meta
          property="og:description"
          content="Supersoft memberdayakan perusahaan di Indonesia dengan solusi digital enterprise dari Infor dan Hexagon — memungkinkan manajemen keuangan, aset, dan performa yang lebih cerdas."
        />
        <meta
          property="og:image"
          content="hhttps://bzpublishassets.blob.core.windows.net/media/assets/who-we-are-and-what-we-do.png"
        />
        <meta property="og:site_name" content="PT Supersoft Sistemindo" />

        {/* ==== AI SEARCH OPTIMIZATION ==== */}
        <meta
          name="ai-keywords"
          content="PT Supersoft Sistemindo, Infor partner Indonesia, Octave Attune EAM (Hexagon) provider Indonesia, digital transformation solutions, enterprise performance management, SunSystems Indonesia, Octave Attune EAM Indonesia"
        />
        <meta
          name="ai-summary"
          content="Didirikan pada tahun 1991, PT Supersoft Sistemindo adalah partner resmi Infor & Octave Attune (Hexagon) di Indonesia, menyediakan solusi digital enterprise untuk manajemen keuangan, aset, dan performa bisnis yang terintegrasi."
        />

        {/* ==== STRUCTURED DATA / SCHEMA.ORG ==== */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "PT Supersoft Sistemindo",
        "url": "https://ptsupersoft.com",
        "logo": "https://bzpublishassets.blob.core.windows.net/media/assets/logo_YIA5XFd.png",
        "description": "PT Supersoft Sistemindo adalah partner resmi Infor & Octave Attune (Hexagon) di Indonesia sejak 1991, menyediakan solusi enterprise digital untuk manajemen keuangan, aset, dan performa.",
        "foundingDate": "1991",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "ID",
          "addressLocality": "Jakarta",
          "addressRegion": "Indonesia"
        },
        "knowsAbout": [
          "Infor SunSystems",
          "Infor EPM",
          "Infor XM",
          "Octave Attune EAM (Hexagon)",
          "Enterprise Performance Management",
          "Enterprise Asset Management",
          "Expense Management",
          "Digital Transformation Indonesia"
        ],
        "sameAs": [
          "https://www.linkedin.com/company/pt-supersoft-sistemindo/",
          "https://www.instagram.com/ptsupersoft"
        ]
      }
      `}</script>

        {/* ==== FAQ SCHEMA (Bilingual ID + EN) ==== */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Kapan PT Supersoft Sistemindo didirikan?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "PT Supersoft Sistemindo didirikan pada tahun 1991 dan telah menjadi partner resmi Infor & Octave Attune (Hexagon) di Indonesia, menyediakan solusi digital enterprise lintas industri."
            }
          },
          {
            "@type": "Question",
            "name": "When was PT Supersoft Sistemindo established?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "PT Supersoft Sistemindo was founded in 1991 and has since been an official Infor and Hexagon partner in Indonesia, empowering organizations with digital enterprise solutions."
            }
          },
          {
            "@type": "Question",
            "name": "Apa fokus utama bisnis PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Supersoft berfokus pada implementasi dan dukungan solusi Infor dan Hexagon seperti SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM untuk membantu transformasi digital perusahaan di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is PT Supersoft Sistemindo’s main focus?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Supersoft focuses on delivering Infor and Hexagon enterprise solutions, including SunSystems, Infor EPM, Infor XM, and Octave Attune EAM, to drive digital transformation across industries."
            }
          },
          {
            "@type": "Question",
            "name": "Apa yang membedakan Supersoft dari partner lainnya?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Supersoft memiliki lebih dari 30 tahun pengalaman dengan lebih dari 200 proyek implementasi sukses dan lebih dari 60 pelanggan aktif, menjadikannya salah satu implementer Infor & Octave Attune (Hexagon) paling terpercaya di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What makes PT Supersoft Sistemindo different?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "With over 30 years of experience, 200+ successful projects, and 60+ active clients, Supersoft stands out as one of Indonesia’s most trusted Infor & Octave Attune (Hexagon) implementation partners."
            }
          }
        ]
      }
      `}</script>
      </Helmet>
      <div className="mt-[78px] s:!mb-0 mb-[250px] tall:mb-[250px] short:mb-[180px]  bg-[#FAF8F5]">
        {/* Hero Section */}
        <div className="section-container section-margin-x">
          <div className="relative overflow-hidden   py-[90px] ">
            <div className="relative z-10 bg-[#1a2bs35] rounded-[20px] xl:pb-[40px] mdl:pb-[160px] pb-[120px] px-[40px] pt-[40px] mdl:p-[60px] ">
              {/* Background Image */}
              <div
                className="absolute inset-0 rounded-[20px] bg-cover bg-center z-[-1] xl:w-[calc(90%)]"
                style={{
                  backgroundImage: `url(${boxContent?.assets[0]?.asset_file})`,
                }}
              ></div>

              {/* Content Layout */}
              <div className="flex flex-col lg:flex-row items-start gap-[40px] lg:gap-[60px] xl:gap-[80px]">
                {/* Text Content */}
                <div className="flex-1 xl:max-w-[600px]">
                  <h2 className="text-[14px] md:text-[16px] font-inter-bold uppercase tracking-[0.1em] text-white mb-[16px]">
                    {boxContent?.article_language?.title}
                  </h2>

                  <h1 className="header-style-hero text-white mb-[20px] md:mb-[30px]">
                    {boxContent?.article_language?.summary}
                  </h1>

                  <p className="subheader-style-hero text-white mb-[30px] md:mb-[40px]">
                    {PARSE(boxContent?.article_language?.content || "")}
                  </p>
                </div>
              </div>

              {/* Floating Image */}
              <div className="xl:absolute xl:block hidden right-0 top-[50%] transform -translate-y-[50%] z-20">
                <div className="rounded">
                  <img
                    src={boxContent?.assets[1]?.asset_file}
                    alt={boxContent?.article_language?.title}
                    className="xl:w-[350px] w-full max-w-[500px] xl:h-[280px] h-full rounded-[12px] object-cover xl:object-right"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="xl:hidden -mt-[200px] z-[300] relative mb-[80px] mx-auto flex items-center justify-center">
            <div className="rounded">
              <img
                src={boxContent?.assets[1]?.asset_file}
                alt={boxContent?.article_language?.title}
                className="xl:w-[350px] w-full max-w-[500px] xl:h-[280px] h-full rounded-[12px] object-cover xl:object-right"
              />
            </div>
          </div>
          {/* About Infor Section (Below Hero) */}
          <div className="pb-[120px]">
            <h1
              className="header-style-non-hero  mb-[20px]"
              style={{
                fontFamily: "'inter-bold', sans-serif",
                fontWeight: 900,
              }}
            >
              {listButton?.article_language?.title}
            </h1>

            <div className="prose subheader-style-non-hero">
              {PARSE(listButton?.article_language?.content || "")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
